<template>
  <div class="D2Form-body-footer">
    <template v-if="!finished">
      <button @click="goPrev()" class="D2Form-btn D2Form-btn--prev u-icon--left" :class="{'is-disabled': disablePrev }"><Icon type="arrow-left-c"></Icon> Anterior</button>

      <button @click="goNext(disableNext)" class="D2Form-btn D2Form-btn--next u-icon--right" :class="{'is-disabled': disableNext }" v-tooltip="disableNext ? 'Preencha todos os campos antes de prosseguir' : ''">
        Próximo <Icon type="arrow-right-c"></Icon>
      </button>
    </template>

    <template v-else>
      <button @click="finish" class="D2Form-btn D2Form-btn--finish u-icon--right" :class="`btn-finalizar--${formState}`">
        <span v-show="formState === 0">Finalizar <Icon type="android-done"></Icon></span>
        <span v-show="formState === 1">Finalizando <Icon type="android-done"></Icon></span>
        <span v-show="formState === 2">Finalizado <Icon type="android-done"></Icon></span>
      </button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    disableNext: Boolean,
    disablePrev: Boolean,
    lead: Boolean,
    finished: {
      type: Boolean,
      default: false
    },
    next: Number
  },
  data () {
    return {
      sent: false,
      formState: 0,
      home_el: null
    }
  },
  methods: {
    send ($home = false) {
      const vm = this

      if ($home && vm.sent === false) {
        // const urlsave = vm.$root.d2debug ? '/d2debug' : '/save'
        this.$axios.post('/save', {
          ...$home.form
        })
        .then(function (response) {
          vm.sent = true
          vm.formState = 2
        })
        .catch(function (error) {
          throw(error)
        })
      } else if (vm.sent) {
        vm.formState = 2
      }
    },
    goNext (disabled) {
      if (!disabled) this.$store.dispatch('ui/nextPage', this.next)
    },
    goPrev () {
      this.$store.dispatch('ui/prevPage')
    },
    finish () {
      const vm = this

      vm.formState = 1

      this.send(this.home_el)

      window.setTimeout(function () {
        vm.formState = 2
      }, 5000)

    },
  },
  mounted () {
    const vm = this
    let $home = null

    try {
      $home = this.$route.matched[0].instances.default
      this.home_el = $home

      $home.$on('sendPlease', function () {
        if (vm.finished) {
          vm.formState = 1
          vm.send($home)
        }
      })

    } catch (e) {
      throw(e)
    }
  }
}
</script>
